import pDebounce from 'p-debounce'
import PQueue from 'p-queue'
import { Platform } from 'quasar'

// const url = process.env.NODE_ENV === 'development' ? '/api/' : 'https://entrega.soluzion.com.br/api/'
const url = 'https://entrega.soluzion.com.br/api/'

function none() { }

function defer() {
  const deferred = {
    onabort: null
  };
  const promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  deferred.promise = promise;
  promise.abort = function (message = 'Abort') {
    deferred.reject(new Error(message));
    deferred.resolve = none;
    deferred.reject = none;
    if (deferred.onabort) deferred.onabort();
  };
  return deferred;
}

export default ({ Vue, store }) => {
  const queue = new PQueue({ concurrency: 1 })

  const getInfo = () => ({
    version: store.state.version,
    is: Platform.is,
    storage: 'idb-keyval'
  });

  const fetchRPC = async (method, params) =>
    queue.add(async () => {
      try {
        const response = await fetch(url, {
          cache: 'no-cache',
          headers: {
            Authorization: `Bearer ${store.state.accessToken}`,
            'X-Client-Version': store.state.version,
          },
          method: 'post',
          body: JSON.stringify({ method, params, info: getInfo() }),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        store.commit('setServerVersion', response.headers.get('X-Server-Version'))
        return response.json();
      } catch (err) {
        if (`${err}`.includes('Failed to fetch')) {
          throw new Error('Sem conexão com a API. Verifique sua internet e tente novamente.');
        } else {
          throw err;
        }
      }
    })

  const requests = [];

  const batchRPC = pDebounce(async () => {
    const arr = requests.splice(0);

    if (arr.length === 0) return;

    try {
      const r = await fetchRPC(
        'batch',
        arr.map(({ method, params }) => ({ method, params }))
      )

      if ('data' in r) {
        arr.forEach((o, i) => {
          // if (process.env.DEV) {
          //   console.log('[RPC]', o.method, o.params, r.data[i]);
          // }
          if ('data' in r.data[i]) o.deferred.resolve(r.data[i]);
          else o.deferred.reject(new Error(r.data[i].error))
        });
      } else {
        const err = new Error(r.error);
        arr.forEach(o => o.deferred.reject(err))
      }
    } catch (err) {
      arr.forEach(o => o.deferred.reject(err))
    }

    if (requests.length) await batchRPC();
  }, 16);

  function rpc(method, params) {
    const id = JSON.stringify({ method, params });
    const found = requests.find(b => b.id === id);
    let deferred;
    if (found) {
      // console.log('deduplicate id', id)
      deferred = found.deferred;
    } else {
      deferred = defer();
      requests.push({ id, method, params, deferred });
      batchRPC()
    }
    const d = defer();
    deferred.promise.then(d.resolve).catch(d.reject);
    return d.promise;
  }

  async function srpc(method, params) {
    const r = await rpc(method, params);
    if (r.error) throw new Error(r.error);
    return r.data;
  }

  Vue.prototype.$rpc = rpc
  store.$rpc = rpc

  Vue.prototype.$srpc = srpc
  store.$srpc = srpc

  if (process.env.NODE_ENV === 'development') {
    window.$rpc = rpc
    window.$srpc = srpc
  }
}
